import React from 'react';
import UserDashboard from '@/pages/UserDashboard';
import Settings from '@/pages/Settings';
import { StaticRouteConfig, LazyRouteConfig } from './types';

// Lazy load admin pages
const MyResults = React.lazy(() => import('@/pages/MyResults'));
const IdealProfilesPage = React.lazy(() => import('@/pages/IdealProfilesPage'));
const PersonComparison = React.lazy(() => import('@/pages/PersonComparison'));
const ManagementStrategy = React.lazy(() => import('@/pages/ManagementStrategy'));
const Org = React.lazy(() => import('@/pages/Org'));
const CompanyManagement = React.lazy(() => import('@/pages/CompanyManagement'));
const IdealProfile = React.lazy(() => import('@/pages/IdealProfile'));
const WorkBehaviorAdmin = React.lazy(() => import('@/pages/WorkBehaviorAdmin'));
const ProfilesPage = React.lazy(() => import('@/pages/ProfilesPage'));
const Training = React.lazy(() => import('@/pages/Training'));
const TeamPage = React.lazy(() => import('@/pages/TeamPage'));
const PositionsPage = React.lazy(() => import('@/pages/PositionsPage'));
const Translation = React.lazy(() => import('@/pages/Translation'));

export const staticAdminRoutes: StaticRouteConfig[] = [
  { path: '/dashboard', component: UserDashboard, protected: true },
  { path: '/admin', component: UserDashboard, protected: true },
  { path: '/settings', component: Settings, protected: true, requireSubscription: false },
];

export const lazyAdminRoutes: LazyRouteConfig[] = [
  { path: '/my-results', component: MyResults, protected: true, skeletonRoute: '/my-results' },
  { path: '/talent', component: PersonComparison, protected: true, skeletonRoute: '/talent' },
  { path: '/comparison', component: PersonComparison, protected: true, skeletonRoute: '/talent' },
  { path: '/positions', component: PositionsPage, protected: true },
  { path: '/ideal', component: IdealProfilesPage, protected: true, skeletonRoute: '/ideal' },
  { path: '/ideal/new', component: IdealProfile, protected: true },
  { path: '/ideal/:id', component: IdealProfile, protected: true },
  { path: '/profiles', component: IdealProfilesPage, protected: true, skeletonRoute: '/ideal' },
  { path: '/profiles/new', component: IdealProfile, protected: true },
  { path: '/profiles/:id', component: IdealProfile, protected: true },
  { path: '/ideal-profiles', component: IdealProfilesPage, protected: true, skeletonRoute: '/ideal' },
  { path: '/ideal-profile/new', component: IdealProfile, protected: true },
  { path: '/ideal-profile/:id', component: IdealProfile, protected: true },
  { path: '/templates', component: ProfilesPage, protected: true },
  { path: '/user-profiles', component: ProfilesPage, protected: true },
  { path: '/org', component: Org, protected: true, skeletonRoute: '/org' },
  { path: '/company', component: CompanyManagement, protected: true, skeletonRoute: '/company' },
  { path: '/company-management', component: CompanyManagement, protected: true, skeletonRoute: '/company' },
  { path: '/management', component: ManagementStrategy, protected: true, skeletonRoute: '/management' },
  { path: '/work', component: WorkBehaviorAdmin, protected: true },
  { path: '/work-behavior-admin', component: WorkBehaviorAdmin, protected: true },
  { path: '/training', component: Training, protected: true },
  { path: '/team', component: TeamPage, protected: true },
  { path: '/translation', component: Translation, protected: true },
];
